import { Injectable, signal } from "@angular/core";

const STORAGE_KEY = "feedback_given";

@Injectable({
  providedIn: "root",
})
export class FeedbackPromptService {
  readonly isOpen = signal(false);

  private openTimerId: ReturnType<typeof setTimeout> | null = null;
  private autoCloseTimerId: ReturnType<typeof setTimeout> | null = null;

  popinTimeoutMs = 20_000;
  popinDelayMs = 300_000;

  init(): void {
    if (this.openTimerId) return;

    if (this.hasAlreadyGivenFeedback()) return;

    this.openTimerId = setTimeout(() => {
      this.open();
      this.openTimerId = null;
    }, this.popinDelayMs);
  }

  open(): void {
    if (this.hasAlreadyGivenFeedback()) return;

    this.isOpen.set(true);

    this.clearAutoCloseTimer();
    this.autoCloseTimerId = setTimeout(() => {
      this.close();
      this.autoCloseTimerId = null;
    }, this.popinTimeoutMs);
  }

  close(): void {
    this.isOpen.set(false);
    this.clearAutoCloseTimer();
  }

  markFeedbackGiven(): void {
    localStorage.setItem(STORAGE_KEY, "1");
    this.close();
  }

  private hasAlreadyGivenFeedback(): boolean {
    return localStorage.getItem(STORAGE_KEY) === "1";
  }

  private clearAutoCloseTimer(): void {
    if (this.autoCloseTimerId) {
      clearTimeout(this.autoCloseTimerId);
      this.autoCloseTimerId = null;
    }
  }
}
